// Sync Protocol Types — Shared between FE (MultiCharts) and Engine (ChartHandle)
// Source of truth: docs/SYNC_PROTOCOL_SPEC.md
export const DEFAULT_THROTTLE_POLICY = {
    visibleRange: { throttleMs: 16, crossTabThrottleMs: 50, debounceMs: 0, maxBatchSize: 10 },
    crosshair: { throttleMs: 16, crossTabThrottleMs: 50, debounceMs: 0, maxBatchSize: 5 },
    drawing: { throttleMs: 100, crossTabThrottleMs: 100, debounceMs: 50, maxBatchSize: 20 },
    symbolLink: { throttleMs: 0, crossTabThrottleMs: 0, debounceMs: 0, maxBatchSize: 1 },
    timeframe: { throttleMs: 0, crossTabThrottleMs: 0, debounceMs: 0, maxBatchSize: 1 },
    chartType: { throttleMs: 0, crossTabThrottleMs: 0, debounceMs: 0, maxBatchSize: 1 },
    drawingTool: { throttleMs: 0, crossTabThrottleMs: 0, debounceMs: 0, maxBatchSize: 1 },
    workspace: { throttleMs: 0, crossTabThrottleMs: 100, debounceMs: 0, maxBatchSize: 1 },
};
